import { useState, useRef, useCallback } from "react";

const useIncreasingNumber = () => {
  const [displayNumber, setDisplayNumber] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const intervalIdRef = useRef<NodeJS.Timeout | null>(null);

  const startAnimation = useCallback(
    (cashAmount: number, duration: number) => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }

      let start = displayNumber;
      const end = cashAmount;
      const frameDuration = 1000 / 60; // Targeting 60 frames per second
      const totalFrames = Math.round(duration / frameDuration);
      const increment = (end - start) / totalFrames;
      setIsAnimating(true);

      const animate = () => {
        start += increment;
        if (
          (increment > 0 && start >= end) ||
          (increment < 0 && start <= end)
        ) {
          start = end; // Ensure we don't overshoot
          if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
          }
          setIsAnimating(false);
        }
        setDisplayNumber(Math.round(start));
      };

      intervalIdRef.current = setInterval(animate, frameDuration);
    },
    [displayNumber]
  );

  const resetDisplayNumber = () => {
    setDisplayNumber(0);
  };

  return { displayNumber, isAnimating, startAnimation, resetDisplayNumber };
};

export default useIncreasingNumber;
